<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .timestamp {
    @include mixins.body2();
    white-space: nowrap;
  }
</style>

<script>
  import { getTimezone } from "../../../../../../../assets/js/src/general/utils";

  let { value, skeleton = false } = $props();

  const LOCALE_WHITELIST = ["en-GB", "en-US"];
  const userLocale = new Intl.NumberFormat().resolvedOptions().locale;
  const LOCALE = LOCALE_WHITELIST.includes(userLocale) ? userLocale : "en-GB";

  const formattedDate = $derived(
    value
      ? new Date(value * 1000).toLocaleDateString(LOCALE, {
          month: "short",
          day: "numeric",
          weekday: "short",
          hour: "numeric",
          minute: "numeric",
          hour12: false,
          timeZone: getTimezone(),
        })
      : "N/A"
  );
</script>

<span class="timestamp" class:skeleton>{formattedDate}</span>
